(function($) {

    $(window).on('load', function() {

        /* Age verification & cookies */

        const ageVerification = document.querySelector('.ageVerification');
        const ageVerificationConfirm = document.querySelector('.ageVerificationButton--confirm');
        const ageVerificationDecline = document.querySelector('.ageVerificationButton--decline');
        const cookies = document.querySelector('.cookies');
        const cookiesClose = document.querySelector('.cookiesClose');
        const cookiesAccept = document.querySelector('.cookiesButton--accept');
        const cookiesOptions = document.querySelector('.cookiesButton--options');
        const cookieInput = document.getElementById('cookies');
        const cookieLabel = document.querySelector('.ageVerificationContent--cookiesLabel');
        const cookieCountry = document.getElementById('country');
        const cookieCountrySelectBlock = document.querySelector('.selectBlock');

        if($('.ageVerification').length > 0) {
            document.body.classList.add('popupOpened');
            document.querySelector('html').classList.add('popupOpened');

            cookieInput.addEventListener('change', function(){
                if(cookieInput.checked) {
                    cookieLabel.classList.remove('err');
                }
            });

            $(document).on('change', 'input[name="age-verification-button"]', function(){
                if($(this).is(':checked')) {
                    $('.yes-no-block').removeClass('err');
                }
            });

            $('.enter-website').click(function(){
                if(($('#cookies').is(':checked')) && ($('#country').val() !== "") && ($('input[name="age-verification-button"]').is(':checked'))) {
                    var age = "";
                    var countryVal = "";
                    if($('input[name="age-verification-button"]:checked').attr('id') === 'confirm') {
                        age = true;
                        countryVal = $('#country').val();
                    } else {
                        age = false;
                        countryVal = "";
                    }
                    setCookie("age", age, 365);
                    setCookie("country", countryVal, 365);
                    location.reload();
                } else {
                    if(!($('#cookies').is(':checked'))) {
                        $('.ageVerificationContent--cookiesLabel').addClass('err');
                    }
                    if($('#country').val() === "") {
                        $('.selectBlock').addClass('err');
                    }
                    if(!($('input[name="age-verification-button"]').is(':checked'))){
                        $('.yes-no-block').addClass('err');
                    }
                }
            });
        }


        if((typeof(cookies) != 'undefined') && (cookies != null)) {
            cookiesClose.addEventListener('click', function () {
                cookies.classList.remove('active');
            });

            cookiesAccept.addEventListener('click', function () {
                cookies.classList.remove('active');
            });

            cookiesOptions.addEventListener('click', function () {
                cookies.classList.remove('active');
            });
        }

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }


    });

})( jQuery );